var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "file-upload-list-item d-flex",
      class: { "file-upload-list-item--undo": _vm.removed },
    },
    [
      _vm.removed
        ? _c("div", { staticClass: "va-row" }, [
            _c(
              "div",
              { staticClass: "flex md12 xs12" },
              [
                _c("vuestic-file-upload-undo", {
                  on: { recover: _vm.recoverFile },
                }),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "va-row align--center" }, [
            _c(
              "div",
              {
                staticClass:
                  "file-upload-list-item__name flex xs12 lg3 ellipsis",
              },
              [_vm._v("\n      " + _vm._s(_vm.file.name) + "\n    ")]
            ),
            _c(
              "div",
              { staticClass: "file-upload-list-item__size flex xs12 lg3" },
              [_vm._v("\n      " + _vm._s(_vm.file.size) + "\n    ")]
            ),
            _c(
              "div",
              { staticClass: "file-upload-list-item__date flex xs12 lg4" },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("fileUpload.uploadedOn")) +
                      " " +
                      _vm._s(_vm.file.date)
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "file-upload-list-item__button-container flex xs12 lg2",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn-text btn-text--primary",
                    attrs: { type: "button" },
                    on: { click: _vm.removeFile },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("fileUpload.delete")) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }